export default {
    v: '5.5.7',
    meta: { g: 'LottieFiles AE 0.1.20', a: '', k: '', d: '', tc: '' },
    fr: 60,
    ip: 0,
    op: 50,
    w: 320,
    h: 500,
    nm: 'sorisso',
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: 'Smiles / Symbol / Color',
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: { x: [0.334], y: [0.993] },
                            o: { x: [0.333], y: [0] },
                            t: 2,
                            s: [0],
                        },
                        {
                            i: { x: [0.833], y: [1] },
                            o: { x: [0.333], y: [0] },
                            t: 30,
                            s: [100],
                        },
                        {
                            i: { x: [0.833], y: [1] },
                            o: { x: [0.167], y: [0] },
                            t: 305,
                            s: [100],
                        },
                        { t: 335, s: [0] },
                    ],
                    ix: 11,
                },
                r: {
                    a: 1,
                    k: [
                        {
                            i: { x: [0.204], y: [1] },
                            o: { x: [0.796], y: [0] },
                            t: 50,
                            s: [0],
                        },
                        { t: 110, s: [360] },
                    ],
                    ix: 10,
                },
                p: {
                    a: 1,
                    k: [
                        {
                            i: { x: 0.683, y: 0 },
                            o: { x: 0.333, y: 0 },
                            t: 2,
                            s: [160, 328.364, 0],
                            to: [0, -2.188, 0],
                            ti: [0, 7.269, 0],
                        },
                        {
                            i: { x: 0.667, y: 0.78 },
                            o: { x: 0.333, y: 0.287 },
                            t: 10,
                            s: [160, 317.133, 0],
                            to: [0, -15.853, 0],
                            ti: [0, 14.185, 0],
                        },
                        {
                            i: { x: 0.667, y: 1 },
                            o: { x: 0.326, y: 1 },
                            t: 21,
                            s: [160, 260.498, 0],
                            to: [0, -8.427, 0],
                            ti: [0, 0.922, 0],
                        },
                        {
                            i: { x: 0.667, y: 0.667 },
                            o: { x: 0.333, y: 0.333 },
                            t: 30,
                            s: [160, 250.5, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: { x: 0.667, y: 1 },
                            o: { x: 0.333, y: 0 },
                            t: 130,
                            s: [160, 250.5, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: { x: 0.667, y: 0.667 },
                            o: { x: 0.333, y: 0.333 },
                            t: 167,
                            s: [160, 229.861, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: { x: 0.667, y: 0.801 },
                            o: { x: 0.333, y: 0 },
                            t: 195,
                            s: [160, 229.861, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: { x: 0.667, y: 1 },
                            o: { x: 0.333, y: 0.477 },
                            t: 223,
                            s: [160, 257.512, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: { x: 0.667, y: 0.667 },
                            o: { x: 0.333, y: 0.333 },
                            t: 240,
                            s: [160, 250.5, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: { x: 0.667, y: 1 },
                            o: { x: 0.333, y: 0 },
                            t: 305,
                            s: [160, 250.5, 0],
                            to: [0, -4.015, 0],
                            ti: [0, 2.186, 0],
                        },
                        { t: 335, s: [160, 180.5, 0] },
                    ],
                    ix: 2,
                },
                a: { a: 0, k: [0, -523.5, 0], ix: 1 },
                s: {
                    a: 1,
                    k: [
                        {
                            i: { x: [0.289, 0.289, 0.667], y: [1, 1, 1] },
                            o: { x: [0.284, 0.284, 0.333], y: [0, 0, 0] },
                            t: 130,
                            s: [25.012, 25.012, 100],
                        },
                        {
                            i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                            o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                            t: 167,
                            s: [34, 34, 100],
                        },
                        {
                            i: { x: [0.407, 0.407, 0.667], y: [1, 1, 1] },
                            o: { x: [0.404, 0.404, 0.333], y: [0, 0, 0] },
                            t: 200,
                            s: [34, 34, 100],
                        },
                        { t: 240, s: [25.012, 25.012, 100] },
                    ],
                    ix: 6,
                },
            },
            ao: 0,
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [-0.482, -0.167],
                                        [-0.074, -0.504],
                                        [-0.005, -2.715],
                                        [0, 0],
                                        [0, 0],
                                        [6.295, -5.911],
                                        [135.661, -0.023],
                                        [0, 0],
                                        [0, 0],
                                        [1.521, 1.573],
                                        [0.138, 7.017],
                                        [0, 0],
                                        [0, 0],
                                        [-0.248, 1.846],
                                        [-0.469, 0.134],
                                        [-0.335, -0.361],
                                        [-0.602, -0.62],
                                        [-1.222, -1.189],
                                        [-1.038, -0.962],
                                        [-26.861, -12.701],
                                        [-63.514, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-1.792, 0.023],
                                        [-1.824, 0.042],
                                        [-0.551, 0.019],
                                        [-56.714, 42.91],
                                        [-0.005, -0.088],
                                        [-3.46, 2.891],
                                        [-2.444, 2.373],
                                        [-0.611, 0.634],
                                        [0, 0],
                                    ],
                                    o: [
                                        [0.469, 0.134],
                                        [0.257, 1.841],
                                        [0, 0],
                                        [0, 0],
                                        [-0.129, 7.012],
                                        [-1.521, 1.573],
                                        [0, 0],
                                        [0, 0],
                                        [-135.661, -0.028],
                                        [-6.29, -5.911],
                                        [0, 0],
                                        [0, 0],
                                        [0, -2.715],
                                        [0.069, -0.504],
                                        [0.464, -0.162],
                                        [0.009, 0],
                                        [0.611, 0.634],
                                        [0.786, 0.763],
                                        [19.105, 18.062],
                                        [37.392, 18.169],
                                        [0, 0],
                                        [0, 0],
                                        [1.815, 0],
                                        [1.824, -0.009],
                                        [0.551, -0.014],
                                        [65.108, -1.702],
                                        [0.005, 0.088],
                                        [4.668, -3.474],
                                        [4.875, -4.07],
                                        [1.231, -1.189],
                                        [0.607, -0.615],
                                        [0.34, -0.361],
                                    ],
                                    v: [
                                        [229.186, -57.931],
                                        [230.068, -56.886],
                                        [230.5, -49.985],
                                        [230.5, -49.36],
                                        [230.5, -49.166],
                                        [221.738, -30.826],
                                        [-0.002, 58],
                                        [-0.002, 57.977],
                                        [-0.002, 58],
                                        [-221.733, -30.826],
                                        [-230.5, -49.166],
                                        [-230.5, -49.36],
                                        [-230.5, -49.985],
                                        [-230.059, -56.89],
                                        [-229.177, -57.936],
                                        [-227.858, -57.584],
                                        [-226.957, -56.645],
                                        [-224.21, -53.898],
                                        [-221.421, -51.266],
                                        [-151.718, -4.72],
                                        [-0.007, 29.299],
                                        [-0.007, 29.304],
                                        [-0.007, 29.299],
                                        [5.36, 29.212],
                                        [10.837, 29.124],
                                        [12.505, 29.091],
                                        [201.011, -34.73],
                                        [201.038, -34.476],
                                        [213.224, -44.069],
                                        [224.205, -53.893],
                                        [226.962, -56.64],
                                        [227.858, -57.579],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: {
                                a: 0,
                                k: [0.20000000298, 0.20000000298, 0.20000000298, 1],
                                ix: 4,
                            },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [0, 0], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [200, 200], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Smiles / Symbol / Color',
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 0,
            op: 340,
            st: 0,
            bm: 0,
        },
    ],
    markers: [{ tm: 150, cm: '0', dr: 0 }],
};
//# sourceMappingURL=in.js.map